module.exports = __webpack_public_path__ + "img/9788983947338.114920a8.jpg";